<div class="currentHoldTimeContent d-flex flex-column">
    <div class="search-box live-search w-75 mx-auto my-2" [hidden]="!searchOpen">
        <input type="search" class="form-control" 
            autocomplete="off" 
            [(ngModel)]="filterValue" 
            (ngModelChangeDebounced)="applyFilter()"
            [ngModelChangeDebounceTime]="400"
            ng-trim="true"
            placeholder="Search" 
            runat="server" 
            cvLocalizedText
            langSection="Common" 
            langKey="Search" />
        <span class="clear-input" role="button" tabindex="0" 
            [hidden]="filterValue.length <= 0" 
            (click)="clearFilter()">
        </span>
    </div>
    
    <ag-grid-angular 
        #topCallTimesGrid
        *ngIf="gridOptions != null"
        [hidden]="this.isFirstLoad" 
        class="ag-theme-balham flex-fill performanceTable"
        [gridOptions]="gridOptions" >
    </ag-grid-angular>
</div>
